module.exports = __webpack_public_path__ + "img/Screenshot-7.470f55f1.png";